import React from "react";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import APIS from "../../constant/EndPoint";
import SwitchButton from "../Reusable/SwitchButton";
//@ts-ignore
import { AccessControl } from "@careinfo/permission-required";
import { useNavigate } from "react-router-dom";

const CityList = (props: any) => {
  const navigate = useNavigate();

  const { handleIsActive } = props;
  const handleRowClick = (row: any) => {
    navigate(`edit/${row.original.id}`);
  };
  const defaultColumns: any = [
    {
      header: "Name",
      accessorKey: "name",
      cell: NACell,
    },
    {
      header: "Code",
      accessorKey: "code",
      cell: NACell,
    },
    {
      header: "District",
      accessorKey: "district_name.name",
      cell: NACell,
    },
    {
      header: "State",
      accessorKey: "state_name.name",
      cell: NACell,
    },
    {
      header: "Country",
      accessorKey: "country_name.name",
      cell: NACell,
    },
    {
      header: "Active",
      accessorKey: "is_active",
      cell: ({ row, getValue }) => (
        <div onClick={(e) => e.stopPropagation()}>
          <AccessControl
            children={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={false}
                onChange={handleIsActive}
              />
            }
            allowedPermissions={["can_update_setting"]}
            renderNoAccess={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={true}
                onChange={handleIsActive}
              />
            }
          />
        </div>
      ),
    },
  ];
  return (
    <DataTable
      url={`${APIS.LOCATION}flat-location/`}
      queryKey={"cities"}
      columns={defaultColumns}
      params={{ level: 3 }}
      addNewPagePath={"/create-city"}
      tableName={"cities"}
      onRowClick={handleRowClick}
    />
  );
};

export default CityList;
